import * as React from "react";

const SYSTEM_VERSION = "__GIT_CHECKSUM__";
export const SystemVersion: React.FC = () => (
  <div className="p-2 text-xs text-gray-400 opacity-50">ver: {SYSTEM_VERSION}</div>
);
